function mapToCssModules(className, cssModule) {
  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

export default mapToCssModules;
//# sourceMappingURL=map-to-css-modules.es.js.map
